export const mutateDocumentsKeys = {
  lockDocuments: ['lockDocuments'] as const,
  unlockDocuments: ['unlockDocuments'] as const,
  deleteDocuments: ['deleteDocuments'] as const,
  createSmallDocumentWithMetadata: ['createSmallDocumentWithMetadata'] as const,
  updateSmallDocumentWithMetadata: ['updateSmallDocumentWithMetadata'] as const,
  updateDocumentMetadata: ['updateDocumentMetadata'] as const,
  validateDocumentMetadata: ['validateDocumentMetadata'] as const,
  downloadManyDocuments: ['downloadManyDocuments'] as const,
  startUploadSession: ['startUploadSession'] as const,
  startNewDocumentUploadSession: ['startNewDocumentUploadSession'] as const,
  uploadChunk: ['uploadChunk'] as const,
  commitUploadSession: ['commitUploadSession'] as const
};
